import { isElement } from "./instanceOf.js";
export default (function (element) {
  return isElement(element) ? element : element.contextElement;
});